//#region src/utils/copyToClipboard.ts
var e = (e) => {
	let t = document.createElement("textarea");
	t.value = e, t.setAttribute("readonly", ""), t.style.position = "absolute", t.style.left = "-9999px", document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t);
}, t = (t) => window.isSecureContext && navigator.clipboard ? navigator.clipboard.writeText(t) : new Promise(() => {
	e(t);
});
//#endregion
export { t as copyToClipboard };
